
<div class="search-bar d-flex flex-column gap-2 pe-1" [style.width.px]="toolbarWidth || null">
  <div class="search-bar-main">
    <!-- Main search input -->
    <div class="search-input-col">
      <div class="input-icon search-input">
        <span class="input-icon-addon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icon-tabler-search"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
            <path d="M21 21l-6 -6" />
          </svg>
        </span>

        <input
          type="text"
          class="form-control"
          [disabled]="loading"
          [ngModel]="searchText"
          (ngModelChange)="onSearchTextChange($event)"
          (keydown.enter)="apply()"
          [placeholder]="placeholder || ('Search ' + (searchFilterSchema?.label || 'records'))"
        />
      </div>
    </div>

    <!-- Option filters -->
    <div
      class="filter-control"
      *ngFor="let field of visibleOptionFilters; trackBy: trackByFieldKey"
    >
      <button
        cdkOverlayOrigin
        #optionOrigin="cdkOverlayOrigin"
        type="button"
        class="btn btn-sm search-filter-btn btn-animate-icon"
        [disabled]="loading"
        [class.active]="isOptionFilterActive(field)"
        [attr.aria-expanded]="isDropdownOpen(field.key)"
        (click)="toggleDropdown($event, field.key)"
      >
        {{ getOptionButtonLabel(field) }}
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-end icon-2"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6 9l6 6l6 -6" /></svg>
      </button>

      <app-floating-dropdown
        [origin]="optionOrigin"
        [open]="isDropdownOpen(field.key)"
        align="end"
        panelClass="p-2 shadow search-filter-menu"
        minWidth="18rem"
        (openChange)="setDropdownOpen(field.key, $event)"
      >
        <ng-container *ngTemplateOutlet="optionEditor; context: {$implicit: field}"></ng-container>
      </app-floating-dropdown>
    </div>

    <!-- Number/date comparison filters -->
    <div
      class="filter-control"
      *ngFor="let field of visibleComparisonFilters; trackBy: trackByFieldKey"
    >
      <button
        cdkOverlayOrigin
        #rangeOrigin="cdkOverlayOrigin"
        type="button"
        class="btn btn-sm search-filter-btn btn-animate-icon"
        [disabled]="loading"
        [class.active]="hasRangeValue(field)"
        (click)="toggleDropdown($event, field.key)"
      >
        {{ getRangeButtonLabel(field) }}
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-end icon-2"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6 9l6 6l6 -6" /></svg>
      </button>

      <app-floating-dropdown
        [origin]="rangeOrigin"
        [open]="isDropdownOpen(field.key)"
        align="end"
        panelClass="p-3 shadow comparison-dropdown"
        minWidth="19rem"
        (openChange)="setDropdownOpen(field.key, $event)"
      >
        <ng-container *ngTemplateOutlet="comparisonEditor; context: {$implicit: field}"></ng-container>
      </app-floating-dropdown>
    </div>

    <div class="filter-control" *ngIf="overflowFilters.length || hasFilters">
      <button
        cdkOverlayOrigin
        #activeFiltersOrigin="cdkOverlayOrigin"
        type="button"
        class="btn btn-sm search-action-btn"
        [class.active]="hasFilters"
        aria-label="More filters"
        [attr.aria-expanded]="moreFiltersOpen"
        [disabled]="loading"
        (click)="toggleMoreFilters($event)"
      >
        Filters
        <span *ngIf="activeFilterCount" class="badge bg-blue text-blue-fg ms-2">{{ activeFilterCount }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-end icon-2"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6 9l6 6l6 -6" /></svg>
      </button>

      <app-floating-dropdown
        [origin]="activeFiltersOrigin"
        [open]="moreFiltersOpen"
        align="end"
        panelClass="p-3 shadow active-filter-menu"
        minWidth="18rem"
        (openChange)="moreFiltersOpen = $event"
      >
        <div class="search-more-filters" (click)="keepDropdownOpen($event)">
          <div class="mb-3" *ngFor="let field of overflowFilters; trackBy: trackByFieldKey">
            <ng-container *ngIf="field.datatype === 'boolean'; else otherFilter">
              <div class="d-flex align-items-center gap-2">
                <label class="form-check form-switch mb-0 flex-fill">
                  <input type="checkbox" role="switch" class="form-check-input"
                    [attr.aria-label]="field.label" [disabled]="loading"
                    [checked]="getSelectedOptionValues(field)[0] === 'true'"
                    (change)="toggleBoolean(field, $any($event.target).checked)" />
                  <span class="form-check-label">{{ field.label }}</span>
                </label>
                <button *ngIf="isOptionFilterActive(field)" type="button" class="btn btn-link btn-sm p-0"
                  [attr.aria-label]="'Clear ' + field.label" (click)="clearOptions(field)">Clear</button>
              </div>
            </ng-container>
            <ng-template #otherFilter>
              <div class="fw-semibold mb-1" *ngIf="field.datatype === 'option'">{{ field.label }}</div>
              <ng-container *ngTemplateOutlet="field.datatype === 'option' ? optionEditor : comparisonEditor; context: {$implicit: field}"></ng-container>
            </ng-template>
          </div>
        </div>
        <div class="d-flex flex-wrap gap-1">
          <span class="badge bg-blue-lt" *ngIf="searchText.trim()">
            Search: {{ searchText }}
          </span>
          <ng-container *ngFor="let field of optionFilters; trackBy: trackByFieldKey">
            <span class="badge bg-secondary-lt" *ngIf="isOptionFilterActive(field)">
              {{ field.label }}: {{ getOptionButtonLabel(field) }}
            </span>
          </ng-container>
          <ng-container *ngFor="let field of comparisonFilters; trackBy: trackByFieldKey">
            <span class="badge bg-purple-lt" *ngIf="hasRangeValue(field)">
              {{ getRangeButtonLabel(field) }}
            </span>
          </ng-container>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <button type="button" class="btn btn-sm text-danger" (click)="clear()">
            Clear filters
          </button>
        </div>
      </app-floating-dropdown>
    </div>

  </div>
</div>

<ng-template #optionEditor let-field>
          <div class="mb-2">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Search {{ field.label }}"
              [(ngModel)]="optionSearchText[field.key]"
            />
          </div>

          <div class="d-flex justify-content-between align-items-center mb-2">
            <button *ngIf="field.selectionMode !== 'single'"
              type="button"
              class="btn btn-link btn-sm p-0"
              (click)="selectAllOptions(field)"
            >
              Select all
            </button>

            <button
              type="button"
              class="btn btn-link btn-sm p-0 text-danger"
              (click)="clearOptions(field)"
            >
              Clear
            </button>
          </div>

          <div class="search-filter-options">
            <label
              class="form-check search-filter-option"
              *ngFor="let option of getFilteredOptions(field); trackBy: trackByOptionValue"
            >
              <input
                [type]="field.selectionMode === 'single' ? 'radio' : 'checkbox'"
                [name]="field.selectionMode === 'single' ? 'search-filter-' + field.key : null"
                class="form-check-input"
                [checked]="isOptionSelected(field, option)"
                (change)="toggleOption(field, option, $any($event.target).checked)"
              />

              <span class="form-check-label text-truncate">
                {{ option.label }}
              </span>
            </label>

            <div
              class="text-muted small px-1 py-2"
              *ngIf="getFilteredOptions(field).length === 0"
            >
              No options found
            </div>
          </div>

</ng-template>
<ng-template #comparisonEditor let-field>
          <div class="mb-2">
            <label class="form-label small mb-1">
              {{ field.label }}
            </label>

            <select
              class="form-select form-select-sm"
              [attr.aria-label]="field.label + ' comparison'"
              [ngModel]="getRangeState(field).operator"
              (ngModelChange)="setRangeOperator(field, $event)"
            >
              <option
                *ngFor="let operator of getOperatorsForField(field)"
                [ngValue]="operator.value"
              >
                {{ operator.label }}
              </option>
            </select>
          </div>

          <ng-container
            *ngIf="getRangeState(field).operator !== 'between'; else betweenInput"
          >
            <div class="mb-2">
              <input
                class="form-control form-control-sm"
                [type]="getInputType(field)"
                [ngModel]="getRangeState(field).value"
                (ngModelChange)="setRangeValue(field, $event)"
                placeholder="Value"
                [attr.aria-label]="field.label + ' value'"
              />
            </div>
          </ng-container>

          <ng-template #betweenInput>
            <div class="row g-2 mb-2">
              <div class="col">
                <label class="form-label small mb-1">
                  From
                </label>

                <input
                  class="form-control form-control-sm"
                  [type]="getInputType(field)"
                  [ngModel]="getRangeState(field).from"
                  [attr.aria-label]="field.label + ' from'"
                  (ngModelChange)="setRangeFrom(field, $event)"
                />
              </div>

              <div class="col">
                <label class="form-label small mb-1">
                  To
                </label>

                <input
                  class="form-control form-control-sm"
                  [type]="getInputType(field)"
                  [ngModel]="getRangeState(field).to"
                  [attr.aria-label]="field.label + ' to'"
                  (ngModelChange)="setRangeTo(field, $event)"
                />
              </div>
            </div>
            <div *ngIf="isInvalidRange(field)" class="small text-danger mb-2" role="alert">
              The start must be before or equal to the end.
            </div>
          </ng-template>

          <div class="d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-link btn-sm text-danger px-0"
              (click)="clearRange(field)"
            >
              Clear
            </button>
          </div>

</ng-template>
